function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.984 20.131l-3.009-3.009-2.007 2.006 3.009 3.01-3.009 3.008 2.007 2.007 3.01-3.01 3.008 3.01L32 25.146l-3.01-3.009L32 19.128l-2.006-2.006-3.009 3.01zM2.836 6.527l11.348 7.133 11.348-7.133v7.972l1.418 1.773 1.419-1.773V3.237a2.392 2.392 0 00-2.39-2.391H2.39a2.392 2.392 0 00-2.392 2.39v17.907c0 1.32 1.071 2.391 2.392 2.391h17.112l1.773-1.41-1.773-1.427H2.836V6.527zm22.556-2.844H2.976l11.208 7.045 11.208-7.045z",
  fill: "#0d5a91"
});

var SvgBespokenIconDeleteEmail = function SvgBespokenIconDeleteEmail(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
};

export default SvgBespokenIconDeleteEmail;